import classNames from 'classnames/bind';
import React, { useMemo } from 'react';

import styles from './common.module.scss';

import { FieldNumber, FieldText } from '@/components/ui/kit/Field';

const cx = classNames.bind(styles);

const Item = ({ data: command }) => {
  const setting = useMemo(() => {
    switch (command.data.setting) {
      case 0:
        return 'Off';
      case 1:
        return 'On';
      default:
        return;
    }
  }, [command.data.setting]);

  return (
    <div className={cx('container')}>
      <label>
        Relay Instance Number
        <div className={cx('fieldWrapper')}>
          <FieldNumber value={command.data.relay} readOnly />
          <span className={cx('unit')} />
        </div>
      </label>
      <label>
        Setting
        <div className={cx('fieldWrapper')}>
          <FieldText value={setting} readOnly />
          <span className={cx('unit')} />
        </div>
      </label>
    </div>
  );
};

export default Item;
